import type {
  CartUpsellDefinition,
  CartUpsellFlowProps,
} from '../cartUpsells.registry'
import { getUpsellWallImageUrls } from '../upsellWall'
import type { AiWallSource, AiWallUpsell, AiWallUpsellId } from './aiWall.types'
import { getAiWallThumbnail, getAiWallWall } from './aiWallTiles'
import { AiWallFlow } from './components/AiWallFlow'
import { AiWallProducer } from './components/AiWallProducer'

export function createAiWallUpsell<Id extends AiWallUpsellId, Candidate>(
  upsell: AiWallUpsell<Id>,
  source: AiWallSource<Id, Candidate>
): CartUpsellDefinition<Id> {
  return {
    experimentFlag: upsell.experimentFlag,
    getCardTitleKey: source.getCardTitleKey,
    cardCtaKey: upsell.cardCtaKey,
    getThumbnail: (offer, [sourcePhoto]) =>
      getAiWallThumbnail({
        tile: upsell.tile,
        offer,
        sourcePhoto,
        sourceCrop: source.getSourceCrop(offer, sourcePhoto),
      }),
    getFlowImageUrls: (offer) =>
      getUpsellWallImageUrls(getAiWallWall(upsell.tile, offer)),
    getAnalyticsProps: (offer) => source.getSourceAnalyticsProps(offer),
    Producer: function Producer() {
      return <AiWallProducer upsell={upsell} source={source} />
    },
    Flow: function Flow(flowProps: CartUpsellFlowProps<Id>) {
      return <AiWallFlow upsell={upsell} {...flowProps} />
    },
  }
}
